const INLINE = new Set(['SPAN', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'SUP', 'SUB', 'BR', 'A', 'SMALL', 'MARK']);

export function prepareReadingExcerpt(html, metadata) {
  if (!metadata || metadata.version !== 1 || typeof html !== 'string') return null;
  const template = document.createElement('template');
  template.innerHTML = html;
  let nodes = [...template.content.childNodes].filter(n => n.nodeType !== 3 || n.textContent.trim());
  if (nodes.length === 1 && nodes[0].tagName === 'DIV' && !nodes[0].attributes.length) {
    nodes = [...nodes[0].childNodes].filter(n => n.nodeType !== 3 || n.textContent.trim());
  }
  if (!nodes.length || nodes.length !== metadata.block_count || nodes.some(n => n.nodeType !== 1 || !/^(P|H[1-6])$/.test(n.tagName))) return null;
  for (const node of nodes) {
    const descendants = [...node.querySelectorAll('*')];
    if (descendants.some(n => !INLINE.has(n.tagName))) return null;
    if ([node, ...descendants].some(n => [...n.attributes].some(a => /^on|^hidden$|^aria-hidden$|^contenteditable$|^data-mini-excerpt/.test(a.name))
      || /(?:display|visibility|content-visibility)\s*:/i.test(n.getAttribute('style') || ''))) return null;
  }
  const selected = metadata.visible_blocks;
  if (!Array.isArray(selected) || !selected.length || selected.length >= nodes.length
    || selected.some((n, i) => !Number.isInteger(n) || n < 0 || n >= nodes.length || (i > 0 && n <= selected[i - 1]))
    || nodes.some((n, i) => /^H[1-6]$/.test(n.tagName) && !selected.includes(i))
    || !selected.some(i => nodes[i].tagName === 'P' && nodes[i].textContent.trim())) return null;
  nodes.forEach((node, index) => { if (!selected.includes(index)) node.setAttribute('data-mini-excerpt-hidden', 'true'); });
  return { html: template.innerHTML, blockCount: nodes.length };
}

export function selectionCrossesHiddenExcerpt(root, range) {
  return [...root.querySelectorAll('[data-mini-excerpt-hidden="true"]')].some(node => range.intersectsNode(node));
}
